<template>
<div class="quote-aside-group mg-b-sm" v-if="assembly">
	<h4 class="f-bold fc-gn pd-t-bs pd-b-sm">
		<!-- {{LANG.smt_price}} -->
		PCB Assembly Price
	</h4>
	<div class="quote-aside_price">
		<div class="thead">
			<div class="tr">
				<div class="th pd-l-lg">
					{{LANG.build_time}}
				</div>
				<div class="th">
					{{LANG.qty}}
				</div>
				<div class="th">
					{{LANG.price}}
				</div>
			</div>
		</div>
		<div class="tbody">			
			<div class="tr active">
				<div class="td">
					<check-box v-model="deltime" class="vlm mg-l-xs" :val="assembly.deltime" :radio="true"  shape="cir"></check-box>
					<span class="vlm mg-l-xs" v-text="assembly.deltime"></span>
				</div>
				<div class="td" v-text="number"></div>
				<div class="td" v-text="'$'+ assembly.total"></div>
			</div>			
		</div>
		<!-- <p class="fc-quotetips pd-t-xs fs-sm" v-text="LANG.quote_result_tips1"></p> -->
		<!-- <div class="quote-aside_price-weight pd-tb-sm">			
			<span  v-if="assembly">{{LANG.weight}}: {{assembly.weight}} kg</span>
		</div> -->
	</div>	
</div>
</template>

<script>
import checkbox from '@/_module/checkbox/index.vue'
export default {
	data(){
		return {
			deltime: ""
		}
	},
	computed:{
		valuation(){
			return this.$store.getters.getQuoteValuation;
		},
		assembly(){
			if(this.valuation && this.valuation.list){
				if(this.valuation.list.assembly){
					//有deltime時
					//this.deltime = this.assembly.deltime;
					return this.valuation.list.assembly;
				}
			}
			return null;
		},
		number(){			
			return this.$store.getters.getQuotesmt_params.number;
		}
	},
	watch:{
		assembly:{
			deep:true,
			immediate:true,
			handler(v){				
				if(v){
					
					this.deltime = v.deltime;
				}				
			}
		}
	},
	components: {
		'check-box':checkbox
	}
}
</script>
